import VendaGuardadaLocalRepository from "../repositories/VendaGuardadaLocalRepository";
import PdvDesktopAdminAuthorizationService from "../services/PdvDesktopAdminAuthorizationService";
import { CAMPOS_VENDA_GUARDADA, criarSnapshotVenda } from "../../../../electron/shared/vendaGuardada";

export default {
  methods: {
    async carregarVendasGuardadas() {
      try {
        this.vendasGuardadas = (await VendaGuardadaLocalRepository.listar()) || [];
        return true;
      } catch (e) {
        this.erroVendasGuardadas = `Não foi possível carregar as vendas guardadas: ${e.message}`;
        return false;
      }
    },

    async abrirVendasGuardadas() {
      if (this.finalizando || this.operacaoVendaGuardada || this.confirmandoVendaGuardada) return;
      this.erroVendasGuardadas = "";
      this.modalVendasGuardadas = true;
      await this.carregarVendasGuardadas();
    },

    async _persistirVendaGuardada(identificacao = "") {
      const dados = criarSnapshotVenda(this);
      await VendaGuardadaLocalRepository.guardar({ dados, identificacao });
      // A transação já liberou os lotes. A tela só é limpa após a gravação.
      this.resetarVenda({ devolverLotes: false });
      this.iniciarNovaVenda();
      await this.carregarVendasGuardadas();
    },

    async guardarVendaAtual() {
      if (this.finalizando || this.operacaoVendaGuardada || this.confirmandoVendaGuardada || !this.carrinho.length) return;
      this.confirmandoVendaGuardada = true;
      try {
        const resultado = await this.$swal.fire({
          title: "Guardar venda para continuar depois",
          input: "text", inputLabel: "Identificação (opcional)",
          inputPlaceholder: "Ex.: Maria, cliente voltou às compras...",
          inputValue: this.clienteManualNome || this.clienteSelecionado?.nome_fantasia || this.clienteSelecionado?.nome || "",
          inputAttributes: { maxlength: 120 }, showCancelButton: true,
          confirmButtonText: "Guardar e iniciar outra venda", cancelButtonText: "Voltar",
        });
        if (!resultado?.isConfirmed) return;
        this.operacaoVendaGuardada = "Guardando venda...";
        this._cancelarEsperaBalanca();
        await this._persistirVendaGuardada(resultado.value || "");
        this.$toast && this.$toast.success("Venda guardada. Você já pode iniciar outro atendimento.");
      } catch (e) {
        this.mensagemErro = `Não foi possível guardar a venda: ${e.message}`;
      } finally {
        this.operacaoVendaGuardada = "";
        this.confirmandoVendaGuardada = false;
      }
    },

    async _aplicarVendaGuardada(dados) {
      this.restaurandoVendaGuardada = true;
      try {
        this.resetarVenda({ devolverLotes: false });
        for (const campo of CAMPOS_VENDA_GUARDADA) {
          if (dados[campo] !== undefined) this[campo] = dados[campo];
        }
        const idForma = dados.formaPagamentoSelecionada?.id;
        this.formaPagamentoSelecionada = this.formasPagamento.find(f => Number(f.id) === Number(idForma)) || this.formasPagamento[0] || null;
        this.descontoVendaAutorizado = false;
        this.itemSelecionadoIdx = -1;
        this.complementaresAberto = !!this.observacaoVenda;
        await this.$nextTick();
      } finally {
        this.restaurandoVendaGuardada = false;
      }
      this.iniciarNovaVenda();
    },

    async recuperarVendaGuardada(venda) {
      if (this.finalizando || this.operacaoVendaGuardada || this.confirmandoVendaGuardada) return;
      this.confirmandoVendaGuardada = true;
      this.modalVendasGuardadas = false;
      this.erroVendasGuardadas = "";
      try {
        if (this.carrinho.length) {
          const resposta = await this.$swal.fire({
            title: "Guardar o atendimento atual?",
            text: "A venda atual será guardada antes de recuperar a venda selecionada.",
            icon: "question", showCancelButton: true,
            confirmButtonText: "Guardar e recuperar", cancelButtonText: "Voltar",
          });
          if (!resposta?.isConfirmed) { this.modalVendasGuardadas = true; return; }
          this.operacaoVendaGuardada = "Guardando o atendimento atual...";
          await this._persistirVendaGuardada();
        }
        this.operacaoVendaGuardada = "Recuperando venda...";
        this._cancelarEsperaBalanca();
        const recuperada = await VendaGuardadaLocalRepository.recuperar(venda.uuid);
        await this._aplicarVendaGuardada(recuperada.dados);
        await this.carregarVendasGuardadas();
        this.$toast && this.$toast.success("Venda recuperada. Continue o atendimento normalmente.");
      } catch (e) {
        this.erroVendasGuardadas = `Não foi possível recuperar a venda: ${e.message}`;
        this.modalVendasGuardadas = true;
        await this.carregarVendasGuardadas();
      } finally {
        this.operacaoVendaGuardada = "";
        this.confirmandoVendaGuardada = false;
      }
    },

    async excluirVendaGuardada(venda) {
      if (this.operacaoVendaGuardada || this.confirmandoVendaGuardada) return;
      this.confirmandoVendaGuardada = true;
      this.modalVendasGuardadas = false;
      this.erroVendasGuardadas = "";
      try {
        const resposta = await this.$swal.fire({
          title: "Excluir venda guardada?", text: venda.identificacao || venda.nome_cliente || "Venda sem identificação",
          icon: "warning", showCancelButton: true, confirmButtonText: "Excluir", cancelButtonText: "Voltar", focusCancel: true,
        });
        if (!resposta?.isConfirmed) return;
        const autorizado = await PdvDesktopAdminAuthorizationService.solicitarAutorizacao(this, "excluir uma venda guardada");
        if (!autorizado) return;
        this.operacaoVendaGuardada = "Excluindo venda guardada...";
        await VendaGuardadaLocalRepository.excluir(venda.uuid);
        await this.carregarVendasGuardadas();
      } catch (e) {
        this.erroVendasGuardadas = `Não foi possível excluir a venda: ${e.message}`;
      } finally {
        this.operacaoVendaGuardada = "";
        this.confirmandoVendaGuardada = false;
        this.modalVendasGuardadas = true;
      }
    },
  },
};
